import { useEffect, useState } from "react";
import { useMyProviderDataClient } from "../../../../context/ApiContext";

// Shape returned by GET /EmployeeInformation/SyncStatus (SyncStatusDTO): when the user's EPR row
// was last synced and their metrics last calculated, for the line under the quarter picker.
export interface SyncStatusData {
  eprSyncedAt: string | null;      // null when the row has no stamp yet
  calculatedAt: string | null;     // null when no metrics for the quarter
  metricsBehindEpr: boolean;       // calculatedAt is older than eprSyncedAt
}

export const useSyncStatus = (username?: string, year?: string, quarter?: number) => {
  const client = useMyProviderDataClient();

  const [data, setData] = useState<SyncStatusData | null>(null);

  useEffect(() => {
    if (!username || !year || !quarter) return;

    let cancelled = false;

    const load = async () => {
      try {
        const res = await client.get("/EmployeeInformation/SyncStatus", {
          params: { username, year, quarter },
        });
        if (!cancelled) setData(res.data);
      } catch (err) {
        // only a status line: the page works without it
        console.error("Sync status load failed", err);
        if (!cancelled) setData(null);
      }
    };

    load();

    // a quarter picked while the previous one is still loading must not be overwritten by it
    return () => {
      cancelled = true;
    };
  }, [username, year, quarter, client]);

  return { data };
};
